import { Button, Form, message, Select, Upload } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { getBankList, getBankAreaList, getBankBranchList } from '@/services/fmsConfig'
import { GeneralFormRefProps } from 'shj-components/dist/es/SGeneralForms/type'
import { startRefundBalance, findCanRefundTrans } from '@/services/order'
import styles from './index.module.less'
import { getToken } from 'shj-utils'
import { getXTransferInsideTenantId } from '@/utils/common'
import { baseURL } from '@/api'
import { UploadOutlined } from '@ant-design/icons'
interface Iprops {
  title: string
  quoteGoodsId: string
  detailsInfo: Record<string, any>
  open: boolean
  orderId: string
  setOpen: (open: boolean) => void
  fn: () => void
}

export default function DrawerToTab(props: Iprops) {
  const { open, title, setOpen, quoteGoodsId, detailsInfo, orderId } = props
  const [tabs, setTabs] = useState<any[]>([])
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  const [fileUrl, setFileUrl] = useState<any>(undefined)
  const formRef = useRef<GeneralFormRefProps>()
  const formDetailsRef = useRef<any>()
  const [fileList, setFileList] = useState<any>([])

  const canRefundAmount = Form.useWatch('canRefundAmount', formRef.current?.onFormRef())

  console.log(detailsInfo)

  useEffect(() => {
    if (open) {
      onFormRef()?.setFieldsValue({
        accountName: detailsInfo.customerName,
      })
    } else {
      onFormRef()?.resetFields()
    }
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        console.log(values)
        values.fileInfos = fileList?.length
          ? fileList?.map(item => {
              return {
                fileName: item.name,
                filePath: item.url,
              }
            })
          : null
        values.orderId = orderId
        values.bankName = values.bankCode.label
        values.bankCode = values.bankCode.value

        values.branchName = values.branchCode.label
        values.branchCode = values.branchCode.value
        setBtnLoading(true)
        startRefundBalance({ ...values })
          .then((res: any) => {
            message.success('提交成功')
            setFileList([])
            onCancel()
          })
          .finally(() => {
            setBtnLoading(false)
          })
        // setBtnLoading(true)
        // setBtnLoading(false)
      })
  }
  const onCancel = () => {
    onFormRef()?.resetFields()
    setFileList([])
    setOpen(false)
  }
  const findCanRefundTransFn = async refundType => {
    findCanRefundTrans({
      orderId,
      refundType,
    }).then((res: any) => {
      console.log(res.dtlList)
      const data = res.dtlList
      data.map((item, index) => {
        if (item.transactionType === 'constructionFee') {
          // 工程款
          formRef.current?.onFormRef()?.setFieldsValue({
            canRefundAmount: item.canRefundAmount,
          })
        } else if (item.transactionType === 'designFee') {
          // 设计费
          formRef.current?.onFormRef()?.setFieldsValue({
            canRefundAmount: item.canRefundAmount,
          })
        }
      })
    })
  }
  const getBankAddress = () => {
    const { bankAreaCode, bankCode } = formRef.current?.onFormRef()?.getFieldsValue() || {}
    if (bankAreaCode && bankCode) {
      getBankBranchList({ bankCode: bankCode.value, areaCode: bankAreaCode }).then(res => {
        formRef.current?.updateState({
          bankBranchList: res,
        })
        formRef.current?.onFormRef().resetFields(['branchCode'])
      })
    }
  }
  const getOptions = async () => {
    const bankLists = await getBankList({
      orderBys: [
        {
          columnName: '',
          asc: false,
        },
      ],
    })
    const bankAreaLists = await getBankAreaList({
      orderBys: [
        {
          columnName: '',
          asc: false,
        },
      ],
    })

    return Promise.resolve({
      bankList: bankLists,
      bankAreaList: bankAreaLists,
    })
  }
  const onbeforeUpload = val => {
    const maxSize = 1024 * 1024 * 50
    if (val && val.size > maxSize) {
      message.warning(val.name + '文件超过50M，上传失败')
      return false
    }
  }
  const onUploadChange = ({ file, fileList }) => {
    let list: any = []
    const maxSize = 1024 * 1024 * 50
    if (file && file.size > maxSize) {
      return
    }
    setFileList([...fileList])
    if (file && file.status === 'done') {
      let data = file.response.data
      list = [
        {
          uid: file?.uid,
          name: data?.originalFilename,
          url: data?.fileUrl,
        },
      ]
      setFileList([...list])
    }
  }
  return (
    <SDrawerOrModal
      title={title}
      open={open}
      onCancel={onCancel}
      width={1010}
      className={styles.second_drawer}
      antdProps={{
        footer: (
          <div style={{ textAlign: 'right' }}>
            <Button loading={btnLoading} style={{ marginRight: '10px' }} onClick={onCancel}>
              取消
            </Button>
            <Button loading={btnLoading} type="primary" onClick={onsubmit}>
              保存
            </Button>
          </div>
        ),
      }}
    >
      <div style={{ margin: '0 10px' }}>
        <SGeneralForms
          ref={formRef}
          layout={'vertical'}
          initialValues={{ realRefundFlag: true }}
          httpOptionsFn={getOptions}
          configs={[
            {
              formItem: [
                {
                  spanCol: 12,
                  label: '余额类型',
                  name: 'balanceType',
                  type: 'radio',
                  required: true,
                  comConfig: {
                    options: [
                      { label: '工程款余额', value: 'refundTypeBalanceConstructionFee' },
                      { label: '设计费余额', value: 'refundTypeBalanceDesignFee' },
                    ],
                    onChange: async (e: any) => {
                      findCanRefundTransFn(e.target.value)
                    },
                  },
                },
                {
                  spanCol: 12,
                  label: '余额',
                  name: 'canRefundAmount',
                  // type: 'inputNumber',
                  required: true,
                  comConfig: {
                    disabled: true,
                  },
                },
                {
                  spanCol: 12,
                  label: '应退金额',
                  name: 'refundAmount',
                  type: 'inputNumber',
                  required: true,
                  comConfig: {
                    max: canRefundAmount,
                    min: 0.01,
                  },
                },
                {
                  spanCol: 12,
                  label: '账户类型',
                  name: 'accountNature',
                  type: 'radio',
                  required: true,
                  comConfig: {
                    options: [
                      { label: '对私', value: 'privateAccount' },
                      { label: '对公', value: 'publicAccount' },
                    ],
                  },
                },
                {
                  label: '客户开户名',
                  name: 'accountName',
                  spanCol: 12,
                  required: true,
                  rules: [{ required: true, message: '请填写' }],
                  comConfig: { disabled: true },
                },
                {
                  label: '客户银行卡号',
                  name: 'accountNumber',
                  spanCol: 12,
                  required: true,
                  // type: 'inputNumber',
                  rules: [
                    {
                      required: true,
                      message: '请填写正确的银行卡号',
                      pattern: /^([1-9]{1})(\d{8,24})$/,
                    },
                  ],
                  // comConfig: { precision: 0, maxLength: 20 },
                },
                {
                  label: '客户银行名称',
                  name: 'bankCode',
                  spanCol: 12,
                  required: true,
                  data: 'bankList',
                  type: 'select',
                  comConfig: {
                    onChange: () => {
                      getBankAddress()
                    },
                    fieldNames: { label: 'bankName', value: 'bankCode' },
                    labelInValue: true,
                  },
                },
                {
                  label: '客户银行省份',
                  name: 'bankAreaCode',
                  spanCol: 12,
                  required: true,
                  data: 'bankAreaList',
                  type: 'select',
                  comConfig: {
                    onChange: () => {
                      getBankAddress()
                    },
                    fieldNames: { label: 'areaName', value: 'areaCode' },
                  },
                },
                {
                  label: '客户银行网点',
                  name: 'branchCode',
                  spanCol: 12,
                  required: true,
                  rules: [{ required: true, message: '请填写' }],
                  type: 'select',
                  data: 'bankBranchList',
                  comConfig: {
                    fieldNames: { label: 'branchName', value: 'branchCode' },
                    labelInValue: true,
                  },
                },
                {
                  spanCol: 12,
                  label: '是否退款',
                  name: 'realRefundFlag',
                  type: 'radio',
                  required: true,
                  comConfig: {
                    options: [
                      { label: '是', value: true },
                      { label: '否', value: false },
                    ],
                  },
                },
                {
                  spanCol: 24,
                  label: '原因备注',
                  name: 'reasonDescription',
                  type: 'textarea',
                  required: false,
                  comConfig: { showCount: true, maxLength: 200 },
                },
                {
                  spanCol: 24,
                  label: '附件',
                  children: (
                    <Upload
                      headers={{
                        Authorization: getToken?.(),
                        'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId(),
                      }}
                      accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.md,.jpg,.jpeg,.gif,.bmp,.png,.tiff,.psd"
                      action={baseURL + `file-web/file/upload`}
                      fileList={fileList}
                      beforeUpload={onbeforeUpload}
                      onChange={onUploadChange}
                      maxCount={1}
                      // onPreview={onPreview}
                    >
                      <Button icon={<UploadOutlined />}>上传附件</Button>
                       <p style={{ color: 'rgb(153, 153, 153)' }}>单个文件大小不能超过50M</p>
                    </Upload>
                  ),
                },
              ],
            },
          ]}
        />
      </div>
    </SDrawerOrModal>
  )
}
